import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetches the product-image manifest once per session.
// Returns { manifest, loading, refetch }. manifest[code] = ['/products/gv-4439.jpg', ...].

let _cache = null;
let _pending = null;

const fetchManifest = async () => {
  if (_cache) return _cache;
  if (!_pending) {
    _pending = axios.get(`${API}/product-images`)
      .then((r) => { _cache = r.data; return _cache; })
      .catch(() => ({}))
      .finally(() => { _pending = null; });
  }
  return _pending;
};

export const useProductImages = () => {
  const [manifest, setManifest] = useState(_cache || {});
  const [loading, setLoading] = useState(!_cache);

  const refetch = async () => {
    _cache = null;
    setLoading(true);
    const m = await fetchManifest();
    setManifest(m);
    setLoading(false);
  };

  useEffect(() => {
    if (_cache) return;
    let mounted = true;
    fetchManifest().then((m) => {
      if (mounted) { setManifest(m); setLoading(false); }
    });
    return () => { mounted = false; };
  }, []);

  return { manifest, loading, refetch };
};

export const invalidateProductImages = () => { _cache = null; };

// First styled ("-clean") image for a code, or null if none exists yet.
// Use this everywhere a plain-background reference photo must never appear
// on first face (cards, marquees, hero stages).
export const cleanImage = (manifest, code) =>
  (manifest?.[code] || []).find((u) => u.includes('-clean')) || null;

export default useProductImages;
